// Custom file obj
export class CFile {
    constructor(json) {
        this.url = json.url;
        this.id = json.id;
    }
}
